export const
  CODE_PATTERN = /^[A-HJ-NP-Z2-9]{5}$/,
  DISCORD_URL_PATTERN = /(?<=(discord\.gg\/))[a-zA-Z0-9]+/,
  SEARCH_STRING_PATTERN = /^[\p{L}0-9-_]{3,}$/u,
  USERNAME_PATTERN = /^[\p{L}0-9-_]{3,20}$/u,
  PLANET_NAME_PATTERN = /^[\p{L}0-9\-_' ]{3,25}$/u,
  OBJECT_ID_PATTERN = /^[0-9]+-[0-9]+$/,
  HTTP_PROTOCOL_PATTERN = /^(http(s?):)?\/\//
;